"use client";

import * as React from "react";
import { CircleQuestionMark } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  id: "item-1",
  question: "How do you protect my personal data and privacy?",
  answer: "We employ industry-standard encryption and strict access protocols to ensure your data remains confidential. Our systems are designed with privacy-by-design principles, ensuring that your information is only used for the purposes you've explicitly consented to."
}, {
  id: "item-2",
  question: "Is your platform fully GDPR and CCPA compliant?",
  answer: "Yes, we are fully committed to global data protection standards. We provide tools for users to exercise their rights, including data portability, the right to be forgotten, and transparent disclosures about how we process information across our infrastructure."
}, {
  id: "item-3",
  question: "What specific data rights do I have as a user?",
  answer: "You have the right to access, correct, or delete your personal information at any time. Additionally, you can object to certain processing activities or request a copy of your data in a structured, machine-readable format through your account settings."
}, {
  id: "item-4",
  question: "Do you share my information with third-party vendors?",
  answer: "We only share data with trusted partners who are essential for providing our services, such as payment processors or hosting providers. Every partner undergoes a rigorous security assessment and is contractually bound to maintain high privacy standards."
}, {
  id: "item-5",
  question: "How long do you retain my data after account closure?",
  answer: "Upon account deletion, we remove your personal data from our active databases within 30 days. Some information may be retained in encrypted backups for a limited period or as required by law for tax and auditing purposes."
}, {
  id: "item-6",
  question: "How can I manage my communication and cookie preferences?",
  answer: "You can customize your privacy experience through our Preference Center. This allows you to opt-in or out of marketing communications and manage which types of cookies are active during your browsing sessions."
}];
export default function Faq() {
  return <section data-section-id="261079" id="faq" className="bg-background text-foreground py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mx-auto max-w-3xl text-center mb-12 md:mb-16">
          <div className="inline-flex items-center justify-center p-3 bg-primary/10 rounded-lg mb-4 shadow-sm">
            <CircleQuestionMark className="size-6 text-primary" />
          </div>
          <h2 className="text-3xl md:text-5xl font-bold font-default text-foreground mb-4 tracking-tight">
            Privacy & Data FAQ
          </h2>
          <p className="text-lg text-muted-foreground font-sans leading-relaxed">
            Find answers to common questions about how we handle your information, your legal rights, and our commitment to transparency.
          </p>
        </div>

        <div className="mx-auto max-w-3xl">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => <AccordionItem key={faq.id} value={faq.id} data-index={i} className="border-border">
                <AccordionTrigger className="text-left text-base md:text-xl font-semibold font-default text-foreground hover:text-primary transition-colors py-6">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground font-sans text-base md:text-lg leading-relaxed pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}